module.exports = __webpack_public_path__ + "static/media/roland - ios.fe813eab.png";